import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

// Categories store their icon as a plain FontAwesome export name (entered in the
// backoffice, e.g. "faCapsules") — resolve it dynamically, falling back to a generic icon.
export function resolveHelpIcon(name) {
    if (!name) return faCircleQuestion;
    return solidIcons[name] || faCircleQuestion;
}

const DEFAULT_TINT = '#2563eb';

export function helpTint(color) {
    return color || DEFAULT_TINT;
}

// Categories only store one color (the foreground tint) — derive a light background tone
// from it instead of asking the backoffice for two separate color fields.
export function helpTintBg(color) {
    const hex = (color || DEFAULT_TINT).replace('#', '');
    const normalized = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
    const value = parseInt(normalized, 16);
    if (Number.isNaN(value)) return '#eff6ff';
    const r = (value >> 16) & 255;
    const g = (value >> 8) & 255;
    const b = value & 255;
    return `rgba(${r}, ${g}, ${b}, 0.12)`;
}
